import { createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit"
import { RootState } from "../../../../../app/store";
import FixtureModel from "../../../models/FixtureModel";

interface fixtureQuickSummaryState {
    selectedFixtures: FixtureModel[],
    showQuickSummaryModal: boolean
}

const initialState: fixtureQuickSummaryState = {
    selectedFixtures: [],
    showQuickSummaryModal: false
}

export const FixtureQuickSummarySlice = createSlice({
    name: "FixtureQuickSummary",
    initialState,
    reducers: {
        setSelectedFixtures: (state, action: PayloadAction<FixtureModel[]>) => {
            state.selectedFixtures = action.payload;
        },
        setShowQuickSummaryModal: (state, action: PayloadAction<boolean>) => {
            state.showQuickSummaryModal = action.payload;
        },
    }
});

export const FixtureQuickSummarySelector = createSelector(
    (state: RootState) => state.fixtureQuickSummary,
    (data) => data
);

export const {
    setSelectedFixtures,
    setShowQuickSummaryModal
} = FixtureQuickSummarySlice.actions;

export default FixtureQuickSummarySlice.reducer;